import { UserInformationProvider, httpOnlySecurityService } from '../iam';
import { useUser, userQueryKey } from '../../hooks/useUser';
import { UserInfo } from '@ipc/iam-react';
import React, { useEffect, useState } from 'react';
import { isPublicRoute } from '../../common/utils/routeUtils';

export const UserInformation: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const auth = httpOnlySecurityService?.isUserAuthenticated() || false;
    const tokenValid = httpOnlySecurityService && !httpOnlySecurityService.isTokenExpired();
    return auth && tokenValid;
  });

  useEffect(() => {
    const checkAuth = () => {
      const auth = httpOnlySecurityService?.isUserAuthenticated() || false;
      const tokenValid = httpOnlySecurityService && !httpOnlySecurityService.isTokenExpired();
      setIsAuthenticated(auth && tokenValid);
    };

    // Check auth status periodically
    const interval = setInterval(checkAuth, 30000);
    return () => clearInterval(interval);
  }, []);

  // Don't make requests on public routes or if token is expired
  const shouldFetch = isAuthenticated && !isPublicRoute();

  // Use the shared useUser hook with the same query key as the rest of the app
  const { data: userInfo, isError } = useUser(shouldFetch);

  if (isError) {
    console.error('Failed to fetch user info');
    return null;
  }

  const user = (userInfo || {}) as UserInfo;
  return <UserInformationProvider userInfo={user}>{children}</UserInformationProvider>;
};
